import { TapiEndpointFactory, stringifyUrl } from '../baseQuery';
import { campaignsSlice } from '../../campaigns';

export const getCampaignsEndpoint: TapiEndpointFactory<'V1CampaignsList'> = (
  builder
) =>
  builder.query({
    query: ({ query }) => stringifyUrl('/campaigns', query),
    onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
      const response = await queryFulfilled;
      dispatch(
        campaignsSlice.actions.campaignsFetched(
          response.data.data.map((apiCampaign) => apiCampaign.attributes)
        )
      );
    },
  });
